import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TableCell from "@material-ui/core/TableCell";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";

import { Amount } from "../../../../components/amount";
import { Async } from "../../../../components/Async";
import { ListTable } from "../../../../components/list_table";
import { QUERY_KEYS } from "../../../../constants";
import { Routing } from "../../../../core/routing";
import { fixAmount } from "../../../../core/utils";
import { ROUTES } from "../../../../routes";
import { IProduct } from "../../data/entities";
import { ProductRepoImpl } from "../../data/repo";
import { calcProductListSummary } from "../../utils";

export const ProductListPage: React.FC = () => {
  const asyncProductList = useQuery(QUERY_KEYS.productList, () => ProductRepoImpl.getList());

  return (
    <div>
      <Box py={3}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          to={Routing.generateCreateRoute(ROUTES.product)}
          component={Link}
        >
          Yarat
        </Button>

        <Box pl={5} component="span">
          <Button to={ROUTES.productHistory} component={Link}>
            Tarixçə
          </Button>
        </Box>
      </Box>

      <Async
        asyncData={asyncProductList}
        renderSuccess={(productList) => {
          return (
            <ListTable<IProduct>
              branch={productList}
              route={ROUTES.product}
              canEdit
              renderHeader={() => (
                <>
                  <TableCell>Mal</TableCell>
                  <TableCell>Çirkli çəki</TableCell>
                  <TableCell>İtki faizi</TableCell>
                  <TableCell>Təmiz çəki</TableCell>
                  <TableCell>Ümumi qiymət</TableCell>
                  <TableCell>Orta qiymət</TableCell>
                </>
              )}
              renderRow={(product) => (
                <>
                  <TableCell>{product.name}</TableCell>
                  <TableCell>{product.dirtyWeight} kq</TableCell>
                  <TableCell>{product.wastePercent} %</TableCell>
                  <TableCell>{product.cleanWeight} kq</TableCell>
                  <TableCell>{product.totalPrice} AZN</TableCell>
                  <TableCell>{product.price} AZN</TableCell>
                </>
              )}
              renderSummary={() => {
                const summary = calcProductListSummary(productList);

                return (
                  <>
                    <TableCell colSpan={2}>Toplam:</TableCell>
                    <TableCell colSpan={2}>{fixAmount(summary.totalDirtyWeight)} kq</TableCell>
                    <TableCell>{fixAmount(summary.totalCleanWeight)} kq</TableCell>
                    <TableCell colSpan={3}>
                      <Amount amount={summary.totalAmount} />
                    </TableCell>
                  </>
                );
              }}
            />
          );
        }}
      />
    </div>
  );
};
